module.exports = __webpack_public_path__ + "static/img/3.6d11499c.png";